// extracted by mini-css-extract-plugin
export default {"content":"not-found_content__WxWN3","bottom":"not-found_bottom__aYq5h"};